module.exports = __webpack_public_path__ + "img/hourglass-split.0c585da6.svg";